module.exports = __webpack_public_path__ + "media/images/upload-2151d74aecc7d94b791d8f9a9d73a3a4.svg";